export const StudentMarkTab = {
  practice_test: 'Practice Tests',
  mock_exam: 'Mock Exams',
}

export const TutorTableTabs = {
  student: 'Student',
}

export const TestTypeItems = [
  { value: 'all', label: 'All' },
  { value: 'common', label: 'Admin Created' },
  { value: 'student_created', label: 'Student Created' },
  { value: 'tutor_created', label: 'Tutor Created' },
]

export const TestResultItems = [
  { value: 'all', label: 'All' },
  { value: 'fail', label: 'Fail' },
  { value: 'pass', label: 'Pass' },
  { value: 'merit', label: 'Merit' },
  { value: 'distinction', label: 'Distinction' },
]
